import { useState, useContext, useEffect } from 'react';
import { format } from 'date-fns';
import { CheckCircleIcon } from '@heroicons/react/24/solid';

import NumberWithButtons from '../../NumberWithButtons';
import DatePicker from '../DatePicker';
import { CheckoutContext } from './CheckoutContext';
import { numberFormat, showToast } from '../../../Utils';

import { 
  getServiceSchedule, 
  getServiceMonthlySchedule, 
  getListAddon } from '../../../api/ServiceAPI';

function CheckoutSchedule(props) {
  const {data, updateData} = useContext(CheckoutContext);
  const [selectedDate, setSelectedDate] = useState(data.schedules.date);
  const [schedule, setSchedule] = useState([]);
  const [addons, setAddons] = useState([]);
  const [selectedSchedule, setSelectedSchedule] = useState([]);

  useEffect(() => {
    const onSuccessHandler = (responseJSON) => {
      setSchedule(responseJSON.times);

      data.schedules.isDP = responseJSON.can_dp;
      updateData(data);
    }
    const onFailureHandler = (messages) => {
      console.debug("FAIL", messages);
      setSchedule([]);
    }
    getServiceSchedule(data.venue.id, data.package.id, format(selectedDate, 'yyyy-MM-dd'), 
      onSuccessHandler, 
      onFailureHandler);
    
    setSelectedSchedule([]);
  }, [data.venue.id, data.package.id, selectedDate]);

  useEffect(() => {
    const onSuccessHandler = (responseJSON) => setAddons(responseJSON);
    const onFailureHandler = (messages) => console.debug("FAIL", messages);
    getListAddon(onSuccessHandler, onFailureHandler);
  }, []);

  const onDaySelected = (day) => {
    data.schedules.date = day;
    updateData(data);
    setSelectedDate(day);
  }

  const scheduleSelected = (schedule) => {
    const selectedSchedules = [...selectedSchedule]
    const existIndex = selectedSchedules.findIndex(selectedHour => selectedHour === schedule.hour)

    if (existIndex >= 0) {
      selectedSchedules.splice(existIndex, 1)
    } else {
      selectedSchedules.push(schedule.hour)
    }

    data.schedules.time = selectedSchedules;
    updateData(data);
    setSelectedSchedule(selectedSchedules);
  }

  const loadCalendarData = (month, callback) => {
    getServiceMonthlySchedule(
      data.venue.id, 
      data.package.id, 
      month.getMonth() + 1, 
      month.getFullYear(), 
      (responseJSON) => {
        let dates = responseJSON.available_times
          .filter((date) => date.times.length > 0)
          .map((date) => date.date_available);
        callback(dates);
      }, 
      (messages) => console.debug("FAIL", messages)
    )
  }

  const checkSchedule = (schedule) => {
    return (selectedSchedule.length > 0) && (selectedSchedule.filter((selectedHour) => selectedHour === schedule.hour).length > 0)
  }

  const updateAddon = (addon, qty) => {
    const selectedAddons = [...data.addons];
    const existIndex = selectedAddons.findIndex(selectedAddon => selectedAddon.id === addon.id);
    
    if (existIndex >= 0) {
      selectedAddons.splice(existIndex, 1)
    }

    if ((qty === undefined) || (qty === null) || (qty === '')) {
      data.addons = selectedAddons;
      updateData(data);
      return;
    }
    
    let addonWithQty = addon;
    addonWithQty.qty = parseInt(qty);

    selectedAddons.push(addonWithQty);
    data.addons = selectedAddons;
    updateData(data);
  }

  const validate = () => {
    if (data.schedules.time.length <= 0)
      return {valid: false, msg: "Silahkan pilih jadwal"};

    return {valid: true, msg: "OK"};
  }

  const onNext = () => {
    let {valid, msg} = validate();

    if (valid) {
      props.onNextPageConfirmed();
    } else {
      showToast("Error", "Alert", msg);
    }
  }

  return (
    <div className='flex w-full flex-col'>

      <div className='md:flex md:gap-6 w-full mt-8'>
        <div className='md:w-1/2 mb-4 md:mb-0 flex flex-col'>
          <p className='text-md font-semibold mb-4'>Pilih Hari</p>

          <div className='bg-[#F5F5F5] p-2 pb-8 rounded-2xl'>
            <DatePicker 
              className='flex w-1/2' 
              selectedDate={selectedDate} 
              onDaySelected={onDaySelected} 
              loadData={loadCalendarData} />
          </div>

        </div>

        <div className='md:w-1/2 flex flex-col'>
          <div className='flex justify-between'>
            <p className='text-md font-semibold mb-4'>Pilih Jam</p>
            <p className='text-md font-semibold mb-4'>
              {format(selectedDate, 'd MMMM yyyy')}
            </p>
          </div>

          {/* <ScheduleListSL /> */}
          <div className='flex flex-col gap-y-2 px-1'>

            {schedule.map((item, index) => {
              if (item.available) {
                return (
                  <div key={index} onClick={(e) => { scheduleSelected(item) }} className='flex items-center justify-between w-full border border-primaryRed text-primaryRed text-sm rounded-lg p-4 cursor-pointer'>

                    <p className='font-medium'>{item.hour}</p>

                    <span className=' flex items-center font-semibold'>
                      {numberFormat(data.package.price)}

                      {checkSchedule(item) ?
                        <CheckCircleIcon className='w-6 text-primaryRed ml-2' />
                        :
                        <CheckCircleIcon className='w-6 text-gray-300 ml-2' />
                      }
                    </span>
                  </div>
                )
              } else {
                return (
                  <div key={index} className='flex items-center justify-between w-full bg-gray-200 border border-gray-300 text-gray-400 text-sm  rounded-lg p-4'>
                    <p className='font-medium'>{item.hour}</p>
                    <span className='flex items-center font-semibold italic'>
                      Sudah di booking
                    </span>
                  </div>
                )
              }

            })}



          </div>



        </div>
      </div>

      <div className='mt-8' >
        <p className='text-md font-semibold mb-4'>Tambah Add On</p>

        <div className='grid md:grid-cols-2 md:border md:border-gray-200 md:rounded-lg overflow-hidden'>

          { addons.map ((addon) => (
            <div key={addon.id} className='flex p-4 items-center border border-gray-200'>
              <img src={process.env.REACT_APP_API_DOMAIN + addon.image.thumb.url} 
                alt={`icon ${addon.name}`} className='w-[25%] max-w-20 m-2 mr-4' />
              <div className='flex-grow flex flex-col m-2' >
                <p className='font-semibold mb-4 text-sm'>{addon.name}</p>
                <span className='flex flex-wrap gap-2 items-center'>
                  <NumberWithButtons onChange={value => updateAddon(addon, value)} />
                  <p className='font-semibold text-sm'>/ {addon.unit}</p>
                </span>
              </div>
            </div>  
          )) }
        </div>
      </div>

      <div className='flex w-full justify-end'>
        <button onClick={onNext} className='w-full md:w-fit bg-primaryRed text-white rounded-lg px-10 py-3 text-sm font-semibold mt-4'>
          Konfirmasi Pesanan
        </button>
      </div>

    </div>

  );
}

export default CheckoutSchedule;